<template>
  <select
    v-model="selected"
    class="Select__box Select__box--radius Search__btn_date_select"
    @change="search(selected)"
  >
    <option value="">
      -- 選択してください --
    </option>
    <option
      v-for="(melontv) of listDay"
      :key="melontv.learning_day"
      :value="melontv.learning_day"
    >
      {{ showDate(melontv.learning_day) }}
    </option>
  </select>
</template>
<script>
import melontvService from '@/services/melontvService'
import moment from 'moment'
export default {
  name: 'MelonTVScheduleModal4Mobile',
  data() {
    return {
      listDay: {},
      seachDay: '',
      selected: ''
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getListClasses()
    },
    async getListClasses() {
      this.$store.dispatch('loading/updateLoading', true)
      const response = await melontvService.index()
      this.listDay = response.data
      this.$store.dispatch('loading/updateLoading', false)
    },
    showDate(date) {
      if (date !== null) {
        this.seachDay = date
        return moment(date).locale('ja').format('MMMDo(ddd)')
      }
    },
    search(day) {
      this.$emit('searchMelonTv', { searchDay: day })
    }
  }
}
</script>
